<template lang='pug'>
  v-app-bar#app-bar(absolute="" app="" dark="" flat="" height="75" :src="barImage" sticky="")
    template(v-slot:img="{ props }")
      // background: linear-gradient(to right, #01cae3 100%, #008e95 100%);
        background-color: #20bf55; background-image: linear-gradient(315deg, #20bf55 0%, #01baef 74%);

      v-img(v-bind="props" :gradient="`to right , #00bfd4, #008e95`")
    span.mr-3(@click="changeDrawer")
      v-icon(v-if="value")
        | mdi-view-quilt
      v-icon(v-else="")
        | mdi-menu
    v-toolbar-title.hidden-sm-and-down.font-weight-bold(v-text="$route.name")
    v-spacer
    .mx-3
      // Notifications
      v-menu(v-model="showMenu" bottom="" left="" offset-y="" origin="top right" transition="scale-transition")
        template(v-slot:activator="{ attrs, on }")
          v-btn.ml-2(min-width="0" text="" v-bind="attrs" v-on="on" @click="$router.replace('/dashboard/notifications')")
            v-badge(v-if="notifications.length > 0" color="red" overlap="" bordered="")
              template(v-slot:badge="")
                span(v-if="notifications.length > 10") 10+
                span(v-else) {{ notifications.length }}
              v-icon mdi-bell
            v-icon(v-else="")
              | mdi-bell
      v-menu(bottom="" left="" min-width="200" offset-y="" origin="top right" transition="scale-transition" style="z-index: 999;")
        template(v-slot:activator="{ attrs, on }")
          v-btn.ml-2(min-width="0" text="" v-bind="attrs" v-on="on")
            v-icon mdi-account
        v-list(:tile="false" flat="" nav="")
          template(v-for="(p, i) in profile")
            v-divider.mb-2.mt-2(v-if="p.divider" :key="`divider-${i}`")
            app-bar-item(v-else="" :key="`item-${i}`" :to="p.logout ? '' : '/dashboard/profile'")
              v-list-item-title(@click="p.logout ? logout() : to " v-text="p.title")
    v-snackbar(v-model='snackbar.show' :color='snackbar.color' right top :timeout="6000")
      | {{snackbar.message}}
      v-btn(dark='' text='' @click='snackbar.show = false')
        | Close
</template>

<script>
  // Components
  import { VHover, VListItem } from 'vuetify/lib'
  import { auth } from '@/plugins/auth/firebase'
  import Cookie from 'js-cookie'
  import loaders from '@/plugins/mixins/loaders'
  import Vue from 'vue'
  // Utilities
  export default {
    name: 'DashboardCoreAppBar',
    filters: {
      timeFrom: function (date) {
        return Vue.moment(date).fromNow()
      },
    },
    components: {
      AppBarItem: {
        render (h) {
          return h(VHover, {
            scopedSlots: {
              default: ({ hover }) => {
                return h(VListItem, {
                  attrs: this.$attrs,
                  class: {
                    'black--text': !hover,
                    'white--text secondary elevation-12': hover,
                  },
                  props: {
                    activeClass: '',
                    dark: hover,
                    link: true,
                    ...this.$attrs,
                  },
                }, this.$slots.default)
              },
            },
          })
        },
      },
    },
    mixins: [loaders],
    props: {
      value: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      showMenu: false,
      profile: [
        { title: 'Mi perfil', to: 'dashboard/profile' },
        { divider: true },
        { logout: true, title: 'Cerrar sesión' },
      ],
      snackbar: {
        show: false,
        message: '',
        color: 'info',
      },
    }),

    computed: {
      notifications () {
        return this.$store.getters['notifications/getNoRead']
      },
      lastNoRead () {
        return this.$store.getters['notifications/getLastNoRead']
      },
      barImage () {
        return this.$store.state.drawer.barImage
      },
      barColor () {
        return this.$store.state.drawer.barColor
      },
      drawer () {
        return this.$store.state.drawer.drawer
      },
      profileUser () {
        return this.$store.state.users.profile
      },
    },
    watch: {
      lastNoRead (newVal, oldVal) {
        const vm = this
        // console.log(newVal, oldVal)
        if (vm.profileUser.showNotifSnack) {
          vm.snackbar.message = newVal
          vm.snackbar.show = true
        }
      },
    },
    created () {
      const vm = this
      vm.loadNoRead()
      this.$store.dispatch('payment/getChangeRestrictions')
    },

    methods: {
      /* open () {
        const vm = this
        if (vm.notifications.length > 0 && vm.showMenu) {
          // Actualizar
          vm.$store.dispatch('notifications/UpdateNoRead')
        }
      },
      goNotifications () {
        if (this.notifications.length > 0) {
          // Actualizar
          // console.log('actualizar')
          this.$store.dispatch('notifications/UpdateNoRead')
          this.$router.replace('notifications')
        }
      }, */
      async logout () {
        const vm = this
        // console.log('logout')
        await auth.signOut()
        await Cookie.remove('access_token')
        vm.$store.dispatch('users/clearUser').then(function () {
          vm.$router.push('/pages/login').catch(err => {
            console.log(err)
          })
        })
      },
      setDrawer (payload) {
        this.$store.dispatch('drawer/set_drawer', payload)
      },
      changeDrawer () {
        // console.log('prueba')
        if (window.innerWidth < 1280) {
          this.setDrawer(!this.drawer)
        } else {
          this.$emit('input', !this.value)
        }
      },
    },
  }
</script>
